import React, { Fragment } from 'react';
import Navbar from '../../components/Navbar/Navbar'
import Hero3 from '../../components/hero3/hero3'
// import PageTitle from '../../components/pagetitle/PageTitle'
import ScrollTextAnimation from '../../components/ScrollTextAnimation/ScrollTextAnimation';
import ServiceSection from '../../components/ServiceSection/ServiceSection';
// import PartnerSection from '../../components/PartnerSection/PartnerSection';
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Logo from '../../images/logo-2.svg'
import CtaSection from '../../components/CtaSection/CtaSection';


const ServicePage = () => {
    return (
        <Fragment>
            <Navbar
                    hclass={'wpo-site-header wpo-header-style'}
                    Logo={Logo}
                    col1={'col-lg-3 col-md-2 col-2 d-lg-none dl-block'}
                    col2={'col-lg-5 col-md-6 col-10'}
                    col3={'col-lg-5 col-md-1 col-1'}
                    col4={'col-lg-2 col-md-2 col-2'}
                  />
                  <Hero3 />
            {/* <PageTitle pageTitle={''} pagesub={'Services'} /> */}
            <ScrollTextAnimation />
           <ServiceSection hclass={'wpo-service-section'} />
            {/* <PartnerSection hclass={'wpo-partners-section fade_bottom'} /> */}
            <CtaSection  hclass={'wpo-cta-section'} />
            <Footer />
            <Scrollbar /> 
        </Fragment>
    )
};
export default ServicePage;



